import { dataPowerOff } from 'dls-icons-data'
import { createIcon } from '../common'

const IconPowerOff = /*#__PURE__*/createIcon(dataPowerOff)
export default IconPowerOff
